import { module } from 'modujs';
import { formDeserialize } from '../utils/html'

/**
    This module serve to alter Filters.js's hidden select.
*/

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            'change': {
                'select': 'update'
            }
        }
    }

    init() {
        this.setFormData()
    }

    /**
     * Set form data
     * Will apply data on a form from url params
     *
     */
    setFormData() {
        const url = new URL(window.location.href)
        if(url.search) {
            formDeserialize(this.el, url.search)
        } else {
            this.el.reset()
        }
    }

    update(e) {
        const value = e.target.value
        this.call('updateSortBy', value, 'Filters')
    }

    reset() {
        this.el.reset()
    }
}
